import { createEntityContext } from "./createEntityContext";

export const {
  EntityContext: ClusterContext,
  EntityProvider: ClusterProvider,
} = createEntityContext("clusters", "/api/skillclusters");
